<template>
  <base-download
          ref="baseDownload"
          :columns="columns"
          :resourceName="resourceName"
          :pk="pk"
          :disabledFilterButton="false"
          :breadcrumbs="breadcrumbs"
          :makerId="makerId"
  >
  </base-download>
</template>

<script>

  export default {
    components: {
    },
    props: {
      makerId: {
        default: 'all',
        required: false
      },
    },
    data() {
      return {
        resourceName: "download_recipes",
        pk: "recipe_id",
        columns: [
          {
            value: "recipe_id",
            text: "システム管理レシピID",
            filter: true,
            type: 'number',
            width: 80
          },
          {
            value: "internal_recipe_id",
            text: "レシピID",
            filter: true,
            width: 80
          },
          {
            value: "maker_id",
            text: "提供メーカー",
            filter: true,
            type: "select",
            optionType: "common/makers",
            isProvider: true
          },
          {
            value: "name",
            text: "レシピ名",
            filter: true
          },
          {
            value: "image",
            text: "料理画像",
            filter: false,
            sorter: false
          },
          {
            value: "publish",
            text: "公開/非公開",
            filter: true,
            width: 80,
            type: 'select',
            optionType: "common/publish"
          }
        ]
      };
    },
    computed: {
      breadcrumbs() {
        return [
          {
            text: "レシピ一括ダウンロード",
            disabled: true
          }
        ];
      }
    }
  };
</script>
